import requestPopupPosition from "./requestPopupPosition";
export default function computeErrorPopupPosition({position,guideOutline,tutorialState}){
  // propose
  let height = tutorialState?.message?.height || 75;
  let width = tutorialState?.message?.width || 300; 

  let oldX = position[0];
  let oldY = position[1];
 
  const extraBump = 20;
  const bigBump = 100;

  let proposedDeltas = [
    [0,0], // BELOW & RIGHT
    [-width,0], // BELOW & LEFT
    [0,-height], // ABOVE & RIGHT
    [-width,-height], // ABOVE & LEFT

    [-extraBump,0],
    [0,-extraBump],
  
    [-width -extraBump ,0],

    [0,-height-extraBump],
    [-width-extraBump,-height-extraBump],
   


    [extraBump, 0],
    [0, extraBump],

    [extraBump,extraBump],  

    [bigBump, 0],
    [0, bigBump],

    [bigBump,bigBump],  
    //[-width,0], 
    //[0,-height], // ABOVE & RIGHT
    //[-width,-height], // ABOVE & LEFT


  ]



  let minimumDistance = Number.POSITIVE_INFINITY;
  let minimumDistanceIndex;
  let posWithMinimumDistance;

  proposedDeltas.forEach(([x,y],ii) => {

    let [newX,newY] = [ x + position[0], y + position[1] ];

    let requestValue = requestPopupPosition({
      position:[newX,newY],
      guideOutline,
      width,
      height
    })

    if( requestValue ){

      let dx = (oldX - newX)**2
      let dy = (oldY - newY)**2

      let distance = Math.sqrt(dx + dy);
      if( distance < minimumDistance ){
        minimumDistance = distance;
        minimumDistanceIndex = ii;
        posWithMinimumDistance = [newX,newY];
      }
    }
  })

  return {
    position:posWithMinimumDistance || [0,0],
    background:(!posWithMinimumDistance && 'red')
  }

}
